module.exports = __webpack_public_path__ + "img/login-bg-7.fa1ec189.jpg";